module.exports = __webpack_public_path__ + "img/slide5.64048b91.jpg";